'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFns = require('date-fns');

var _isDisabled = require('./isDisabled.date');

var _isDisabled2 = _interopRequireDefault(_isDisabled);

var _alert = require('../../../libs/alert');

var _alert2 = _interopRequireDefault(_alert);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Libs


exports.default = function (stringDate, disabledDates) {
  var notify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var dateObject = (0, _dateFns.parse)(stringDate);
  if (!dateObject || !stringDate) return false;

  if ((0, _isDisabled2.default)(disabledDates, dateObject)) {
    if (notify) _alert2.default.warning('This date is disabled');
    return true;
  }

  return false;
};